import { render, staticRenderFns } from "./ringInfo.vue?vue&type=template&id=af3534f4&scoped=true&"
import script from "./ringInfo.vue?vue&type=script&lang=js&"
export * from "./ringInfo.vue?vue&type=script&lang=js&"
import style0 from "./ringInfo.vue?vue&type=style&index=0&id=af3534f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3534f4",
  null
  
)

export default component.exports